import React, { useState } from 'react';
import QueryStringNavigate from '../../QueryStringNavigate';

import useOutsideClick from '../../../hooks/useOutsideClick';

import * as S from './NavMenu.styled';
import { SplitRow } from '../SeoNavBar.styles';

const Arrow = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>arrow</title>
    <path
      d="M15.8652 12.3262L10.096 8.67233L4.32677 12.3262"
      stroke="#3C3C3B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

const ItemParent = ({ label, href, hasSubMenu, children, id }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const handleExpandMenu = () => setIsExpanded(!isExpanded);
  const handleCollapseMenu = () => setIsExpanded(false);
  const isLink = !!href;

  const ref = useOutsideClick(handleCollapseMenu);

  return (
    (hasSubMenu || isLink) && (
      <S.ItemParent
        ref={ref}
        onClick={handleExpandMenu}
        isExpanded={isExpanded}
      >
        {isLink && (
          <QueryStringNavigate id={id} path={href}>
            {label}
            <S.Underline />
          </QueryStringNavigate>
        )}
        {hasSubMenu && (
          <>
            <SplitRow>
              {label} <Arrow />
            </SplitRow>

            {children}
          </>
        )}
      </S.ItemParent>
    )
  );
};

export default ItemParent;
